// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3bf3r","footer":"ModalError_footer__2RhyX"};